import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Fade } from "react-reveal";
import {
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Steper from "Component/Steper/Steper";
import Selecttokenmod from "Component/Modals/Selecttokenmod";

import { useNavigate } from "react-router-dom";

const Sellorderpage = (props) => {
  const navigate = useNavigate();
  const [selecttoken, setselectoken] = useState(false);

  const handleback = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  return (
    <Fade>
      <Selecttokenmod show={selecttoken} onHide={() => setselectoken(false)} />

      <section className="home_banner_main buy_page position-relative">
        <div className="top_circle"></div>

        <Container fluid className="position-relative container_postition">
          <Row>
            <Col lg={6} md={12} sm={12} className="m-auto">
              <div className="common_box_wrap">
                <div className="trassaction_mod_inner position-relative">
                  <a
                    href="javascript:void(0)"
                    className="arrow-back d-flex align-items-center gap-2"
                    onClick={handleback}
                  >
                    <span className="me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 40 30"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_48_5634)">
                          <path
                            d="M3.23437 13.2344C2.25781 14.2109 2.25781 15.7969 3.23437 16.7734L15.7344 29.2734C16.7109 30.25 18.2969 30.25 19.2734 29.2734C20.25 28.2969 20.25 26.7109 19.2734 25.7344L11.0312 17.5L35 17.5C36.3828 17.5 37.5 16.3828 37.5 15C37.5 13.6172 36.3828 12.5 35 12.5L11.0312 12.5L19.2656 4.26562C20.2422 3.28906 20.2422 1.70312 19.2656 0.72656C18.2891 -0.250003 16.7031 -0.250003 15.7266 0.72656L3.22656 13.2266L3.23437 13.2344Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_48_5634">
                            <rect
                              width="30"
                              height="40"
                              fill="white"
                              transform="translate(0 30) rotate(-90)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>

                    <h4 className="m-0">Sell Crypto</h4>
                  </a>

                  <div className="buy_crypto_list mt-4">
                    <Form className="sell_crypto_form">
                      <div className="sell_ertw d-flex align-items-center justify-content-between mb-3">
                        <h4 className="m-0">Sell ERC-20 USDT </h4>
                        <div className="drop_down_three">
                          <UncontrolledDropdown>
                            <DropdownToggle className="btn_three_dots">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="5"
                                height="19"
                                viewBox="0 0 5 19"
                                fill="none"
                              >
                                <circle
                                  cx="2.5"
                                  cy="2.5"
                                  r="2.5"
                                  fill="#181924"
                                />
                                <circle
                                  cx="2.5"
                                  cy="9.5"
                                  r="2.5"
                                  fill="#181924"
                                />
                                <circle
                                  cx="2.5"
                                  cy="16.5"
                                  r="2.5"
                                  fill="#181924"
                                />
                              </svg>
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem>Another Action</DropdownItem>
                              <DropdownItem>Another Action</DropdownItem>
                              <DropdownItem>Another Action</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </div>
                      </div>

                      <div className="text-start">
                        <FormGroup className="position-relative">
                          <Label for="exampleEmail">You Send</Label>

                          <div className="d-flex align-items-center border rounded p-2">
                            <Input
                              type="number"
                              name="email"
                              id="exampleEmail"
                              placeholder="323.895234"
                            />

                            <div className="chain_name position-relative">
                              <div className="sellchain_icon">
                                <img
                                  src="/images/USDTeth.png"
                                  alt=""
                                  className="img-fluid"
                                />
                              </div>
                              USDT
                            </div>
                          </div>
                        </FormGroup>

                        <FormGroup className="position-relative">
                          <Label for="exampleEmail">You Get</Label>

                          <div className="d-flex align-items-center border rounded p-2">
                            <Input
                              type="number"
                              name="email"
                              id="exampleEmail"
                              placeholder="300.00"
                            />

                            <div className="chain_name position-relative">
                              USDT
                            </div>
                          </div>
                        </FormGroup>
                      </div>

                      <div className="your_order_details d-flex align-items-center justify-content-between py-3">
                        <h6>Your Order</h6>

                        <div className="your_order_content">
                          <div className="d-flex align-items-center">
                            <p className="sell_price m-0">
                              <strong>$300.00</strong> for 323.89
                            </p>
                            <FormGroup className="selected_div">
                              <Input
                                type="select"
                                name="select"
                                id="exampleSelect"
                                className="py-0 border-0"
                              >
                                <option>USDT</option>
                                <option>USDT</option>
                                <option>USDT</option>
                                <option>USDT</option>
                              </Input>
                            </FormGroup>
                          </div>

                          <div className="updated_count d-flex align-items-center justify-content-end px-3">
                            <p>All Fees Included</p>
                            <span className="mx-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="11"
                              height="11"
                              viewBox="0 0 11 11"
                              fill="none"
                            >
                              <g clip-path="url(#clip0_129_2237)">
                                <path
                                  d="M5.50008 9.16669C6.47254 9.16669 7.40517 8.78038 8.09281 8.09275C8.78044 7.40511 9.16675 6.47248 9.16675 5.50002C9.16675 4.52756 8.78044 3.59493 8.09281 2.9073C7.40517 2.21966 6.47254 1.83335 5.50008 1.83335C4.52762 1.83335 3.59499 2.21966 2.90736 2.9073C2.21972 3.59493 1.83341 4.52756 1.83341 5.50002C1.83341 6.47248 2.21972 7.40511 2.90736 8.09275C3.59499 8.78038 4.52762 9.16669 5.50008 9.16669ZM5.50008 0.916687C6.10197 0.916687 6.69797 1.03524 7.25405 1.26557C7.81012 1.49591 8.31539 1.83351 8.74099 2.25911C9.16659 2.68472 9.5042 3.18998 9.73453 3.74605C9.96486 4.30213 10.0834 4.89813 10.0834 5.50002C10.0834 6.7156 9.60053 7.88138 8.74099 8.74093C7.88145 9.60047 6.71566 10.0834 5.50008 10.0834C2.9655 10.0834 0.916748 8.02085 0.916748 5.50002C0.916748 4.28444 1.39963 3.11866 2.25918 2.25911C3.11872 1.39957 4.28451 0.916687 5.50008 0.916687ZM5.72925 3.20835V5.6146L7.79175 6.83835L7.448 7.4021L5.04175 5.95835V3.20835H5.72925Z"
                                  fill="#A098AE"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_129_2237">
                                  <rect width="11" height="11" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                            </span>
                            <p>Updated in 8 sec</p>
                          </div>
                        </div>
                      </div>

                      <Button className="btn_sign_in w-100 btn_theme" onClick={()=> navigate("/transaction")}>
                        Sell USDT now
                      </Button>
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="bottom_circle"></div>
      </section>
    </Fade>
  );
};

export default Sellorderpage;
